//Check from local storage is borrower onboarding or not
export function Investor() {
  const url = localStorage.redirect_path_after_login || ''
  return url.includes('/borrower/onboarding') ? false : true
}
